module.exports = __webpack_public_path__ + "static/media/logo_text.4715b05c.svg";